<template>
  <div class="page">
    <div class="titleView">
      <div class="line"></div>
      <div class="titleName">基础设置</div>
    </div>
    <!-- 信息 -->
    <div class="view">
      <div class="com" v-if="categoryData.length != 0">
        <div class="mr">分类:</div>
        <el-cascader
          size="small"
          filterable
          ref="cascader"
          clearable
          v-model="categoryId"
          :options="categoryData[0].children"
          :show-all-levels="true"
          :props="{ label: 'label', value: 'id' }"
          @change="changeCategory"
          style="width: 200px"
          placeholder="请选择分类"
        ></el-cascader>
      </div>
      <div class="com">
        <div class="mr">礼包名称:</div>
        <el-input
          placeholder="请输入礼包名称"
          v-model="title"
          clearable
          style="width: 200px"
          size="small"
        >
        </el-input>
      </div>
      <div class="com">
        <div class="mr">礼包简介:</div>
        <el-input
          placeholder="请输入礼包简介"
          v-model="desc"
          clearable
          style="width: 200px"
          size="small"
        >
        </el-input>
      </div>
      <div class="com">
        <div class="mr">礼包级别:</div>
        <el-select
          size="small"
          v-model="gift_bag_level"
          placeholder="请选择礼包级别"
          value-key="value"
          style="width: 200px"
        >
          <el-option
            v-for="item in levelData"
            :key="item.value"
            :label="item.title"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="com">
        <div class="mr">适用品种:</div>
        <el-select
          size="small"
          v-model="apply_type"
          placeholder="请选择适用品种"
          value-key="value"
          style="width: 200px"
        >
          <el-option
            v-for="item in applyType"
            :key="item.value"
            :label="item.title"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="com">
        <div class="mr">封面图:</div>
        <el-upload
          class="avatar-uploader"
          action="https://res.huashengchongwu.com/api/media/oss/upload?dir='appImg'"
          :show-file-list="false"
          :http-request="uploadCoverImg"
        >
          <img v-if="cover" :src="cover" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="com">
        <div class="mr">分享图:</div>
        <el-upload
          class="avatar-uploader"
          action="https://res.huashengchongwu.com/api/media/oss/upload?dir='appImg'"
          :show-file-list="false"
          :http-request="uploadShareImg"
        >
          <img v-if="shareCover" :src="shareCover" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="com">
        <div class="mr">轮播图:</div>
        <el-button size="small" @click="handleUploadClick">上传图片</el-button>
        <input
          type="file"
          ref="file"
          style="width: 0; height: 0"
          @change="changeFile"
        />
      </div>
      <div class="com">
        <div class="mr"></div>
        <el-table :data="bannerList" border style="flex: 0.6">
          <el-table-column label="排序" align="center" prop="order">
          </el-table-column>
          <el-table-column prop="url" label="图片" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 60px; height: 60px"
                :src="scope.row.url"
                :preview-src-list="[scope.row.url]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="center">
            <template slot-scope="scope">
              <el-input
                placeholder="请输入图片名称"
                v-model="scope.row.name"
                clearable
                size="small"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleSortChange(scope.$index, scope.row, 1)"
                type="text"
                size="small"
                >前移
              </el-button>
              <el-button
                @click="handleSortChange(scope.$index, scope.row, 2)"
                type="text"
                size="small"
                >后移
              </el-button>
              <el-button
                @click="handleDeleteClick(scope.$index)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="com">
        <div class="mr">详情图:</div>
        <div class="imgView">
          <div
            v-for="(item, index) in detailImgList"
            :key="index"
            class="imgItem"
          >
            <img
              alt=""
              :src="item"
              v-if="detailImgList.length > 0"
              style="border-radius: 6px"
            />
            <i
              class="el-icon-error closeBtn"
              v-if="detailImgList.length > 0"
              @click="handleDeleteImgClick(index)"
            ></i>
          </div>
          <i
            class="el-icon-plus avatar-uploader-icon"
            style="border: 1px dashed #d9d9d9; border-radius: 6px"
            @click="handleUploadDetailClick"
          ></i>
          <input
            type="file"
            ref="fileDetail"
            style="width: 0; height: 0"
            @change="changeDetailFile"
          />
        </div>
      </div>
      <!-- 礼包信息 -->
      <div class="com">
        <div class="mr">礼包计划:</div>
        <el-button @click="handelNewPlanClick" size="small">新建计划</el-button>
        <el-button
          @click="handleSelectClick"
          size="small"
          v-if="gift_bag_plans.length != 0"
          >添加商品</el-button
        >
      </div>
      <div class="com">
        <div class="mr"></div>
        <div style="display: flex; flex-wrap: wrap">
          <div
            v-for="(item, index) in gift_bag_plans"
            :key="index"
            :class="planIndex == index ? 'planNameS' : 'planName'"
            @click="handelTabClick(index)"
          >
            <el-input
              placeholder="请输入计划名称"
              v-model="item.name"
              size="small"
              style="width: 130px"
            >
            </el-input>
            <div
              style="margin-left: 10px"
              @click="handelDeletePlanClick(index)"
            >
              删除
            </div>
          </div>
        </div>
      </div>
      <div class="com" v-if="gift_bag_plans.length != 0">
        <div class="mr"></div>
        <el-input
          size="mini"
          style="width: 100px; vertical-align: middle"
          v-model="plan_items.times"
        >
          <template slot="append">次</template>
        </el-input>
        <el-input
          size="mini"
          style="
            width: 150px;
            margin-left: 10px;
            vertical-align: middle;
            margin-right: 10px;
          "
          v-model="plan_items.price"
        >
          <template slot="append">价格</template>
        </el-input>
        <el-input
          size="mini"
          style="
            width: 150px;
            margin-left: 10px;
            vertical-align: middle;
            margin-right: 10px;
          "
          v-model="plan_items.marking_price"
        >
          <template slot="append">划线价</template>
        </el-input>
      </div>
      <div class="com" v-if="gift_bag_plans.length != 0">
        <div class="mr"></div>
        <el-table :data="plan_items.goods" border>
          <el-table-column label="类别" align="center" prop="categoryName">
          </el-table-column>
          <el-table-column
            label="商品名称"
            align="center"
            prop="goods_name"
            width="300px"
          >
          </el-table-column>
          <el-table-column label="品牌" align="center" prop="brand">
          </el-table-column>
          <el-table-column label="规格" align="center" prop="sku_name">
          </el-table-column>
          <el-table-column
            label="包装单位"
            align="center"
            prop="packing_way_name"
          >
          </el-table-column>
          <el-table-column label="数量" align="center" prop="count">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.count"
                :min="0"
                size="small"
                style="width: auto"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="是否多次循环配送" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.is_many_times_execute"
                placeholder="请选择"
                size="small"
                style="width: 60px"
              >
                <el-option
                  v-for="item in times"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleDeleteGoodsClick(scope.$index)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="pageRightBtn">
      <el-button @click="handleBackClick" size="small">返回</el-button>
      <el-button type="warning" @click="handelSubmitClick" size="small"
        >提交</el-button
      >
    </div>
    <!-- 添加商品弹框 -->
    <div v-if="dialogOnlineGoods_state">
      <dialogOnlineGoods
        @closeOn="dialogOnlineGoods_state = false"
        :onlineState.sync="dialogOnlineGoods_state"
        @submit="selectShop"
      ></dialogOnlineGoods>
    </div>
  </div>
</template>

<script>
import dialogOnlineGoods from "../../../components/dialog_onlineGoods.vue";
import {
  getProductType,
  setPetGift,
  getPetGiftDl,
} from "../../../api/program.js";
import { getProductTypeDl } from "../../../api/productApi.js";
import { uploadImg } from "../../../api/stockApi.js";
export default {
  components: {
    dialogOnlineGoods,
  },
  data() {
    return {
      applyType: [
        {
          //适用品种
          value: "1",
          title: "猫",
        },
        {
          value: "2",
          title: "狗",
        },
        {
          value: "0",
          title: "通用",
        },
      ],

      levelData: [
        {
          //礼包级别
          value: "0",
          title: "无级别",
        },
        {
          value: "1",
          title: "初级",
        },
        {
          value: "2",
          title: "中级",
        },
        {
          value: "3",
          title: "高级",
        },
      ],
      times: [
        {
          //是否多次配送
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      categoryData: [], //分类数据
      category_info: {}, //选中分类
      category_list: [], //选中分类上级列表
      title: "", //礼包标题
      desc: "", //礼包简介
      cover: "", //封面图
      productTypeIds: "", //礼包id
      shareCover: "", //分享图
      gift_bag_level: {}, //礼包级别
      apply_type: {}, //适用品种
      bannerList: [], //图片表格
      detailImgList: [], //详情图片列表
      gift_bag_plans: [], //礼包计划
      plan_items: {}, //计划信息
      planIndex: 0, //默认选中计划
      dialogOnlineGoods_state: false,
      id: "", //礼包id
      categoryId: "",
    };
  },
  created() {
    this.getProductType();
    if (this.$route.query.id) {
      console.log("编辑");
      this.id = this.$route.query.id;
      this.getPetGiftDl();
    }
  },
  methods: {
    //获取详情
    getPetGiftDl() {
      let params = {
        id: this.id,
      };
      getPetGiftDl(params).then((res) => {
        if (res.code == 0) {
          console.log("详情", res.data);
          this.apply_type = res.data.apply_type;
          this.title = res.data.title;
          this.categoryId = res.data.category_info._id;
          this.category_info = res.data.category_info;
          this.category_list = res.data.category_list;
          this.cover = res.data.cover;
          this.bannerList = res.data.banner_list;
          this.detailImgList = res.data.detail_img_list;
          this.shareCover = res.data.share_cover;
          this.desc = res.data.desc;
          this.gift_bag_level = res.data.gift_bag_level;
          this.gift_bag_plans = res.data.gift_bag_plans;
          this.plan_items = res.data.gift_bag_plans[0];
        }
      });
    },
    //提交
    handelSubmitClick() {
      console.log(this.category_info);
      let params = {
        apply_type: this.apply_type,
        title: this.title,
        category_info: this.category_info,
        category_list: this.category_list,
        cover: this.cover,
        banner_list: this.bannerList,
        detail_img_list: this.detailImgList,
        share_cover: this.shareCover,
        desc: this.desc,
        gift_bag_level: this.gift_bag_level,
        gift_bag_plans: this.gift_bag_plans,
      };
      if (this.id != "") {
        params.giftBagId = this.id;
      }
      setPetGift(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "已提交",
          });
          this.$router.back();
        }
      });
      console.log(params);
    },
    //删除商品
    handleDeleteGoodsClick(index) {
      this.gift_bag_plans[this.planIndex].goods.splice(index, 1);
    },
    //选中商品
    selectShop(item) {
      console.log("选择商品", item);
      for (let i = 0; i < item.sku_extend_info.length; i++) {
        let obj = {
          goods_id: item._id,
          goods_type: item.goods_type,
          goods_name: item.online_name,
          sku_id: item.sku_extend_info[i].sku_id,
          sku_name: item.sku_extend_info[i].online_sku_unit_name,
          packing_way_id: item.sku_extend_info[i].unit_id,
          count: 1,
          brand: item.brand_name,
          categoryName: item.online_category_info.name,
          packing_way_name: item.sku_extend_info[i].unit_name,
          is_many_times_execute: 0, //是否多次配送   0否1是
        };
        this.plan_items.goods.push(obj);
      }
    },
    //添加商品
    handleSelectClick() {
      this.dialogOnlineGoods_state = true;
    },
    //计划切换
    handelTabClick(index) {
      this.planIndex = index;
      this.plan_items = this.gift_bag_plans[index];
    },
    //删除计划
    handelDeletePlanClick(index) {
      this.gift_bag_plans.splice(index, 1);
    },
    //创建计划
    handelNewPlanClick() {
      let obj = {
        plan_id: "",
        name: "",
        times: 0,
        price: 0,
        marking_price: 0,
        goods: [], //商品信息
      };
      this.gift_bag_plans.push(obj);
      if (this.gift_bag_plans.length == 1) {
        this.plan_items = this.gift_bag_plans[0];
      }
      console.log(this.gift_bag_plans);
    },
    //上传详情图
    changeDetailFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext1 = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      var ext = ext1.toLowerCase();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util.uploadImg_dir(formData, { dir: "appImg" }).then((data) => {
          if (data.timestamp) {
            this.detailImgList.push(data.url);
          }
        });
      } else {
        this.$message({
          message: "只能上传jpg,jpeg,png格式的文件",
          type: "error",
        });
        return;
      }
      this.$refs.file.value = null;
    },
    //转移详情图
    handleUploadDetailClick() {
      this.$refs.fileDetail.click();
    },
    //删除对应图片
    handleDeleteImgClick(index) {
      this.detailImgList.splice(index, 1);
    },
    //删除轮播图
    handleDeleteClick(index) {
      this.$confirm("是否删除当前图片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let bannerList = [...this.bannerList];
          bannerList.splice(index, 1);
          for (let i = 0; i < bannerList.length; i++) {
            bannerList[i].order = i;
          }
          this.bannerList = bannerList;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //排序
    handleSortChange(index, row, type) {
      console.log(index, row);
      if (type == 1) {
        console.log("前移");
        if (index == 0) {
          this.$message({
            type: "error",
            message: "已是第一位",
          });
        } else {
          let bannerList = [...this.bannerList];
          let copy = this.bannerList[index];
          bannerList.splice(index, 1);
          bannerList.splice(index - 1, 0, copy);
          for (let i = 0; i < bannerList.length; i++) {
            bannerList[i].order = i;
          }
          this.bannerList = bannerList;
        }
      } else {
        console.log("后移");
        if (index == this.bannerList.length - 1) {
          this.$message({
            type: "error",
            message: "已是最后一位",
          });
        } else {
          let bannerList = [...this.bannerList];
          let copy = this.bannerList[index];
          bannerList.splice(index, 1);
          bannerList.splice(index + 1, 0, copy);
          for (let i = 0; i < bannerList.length; i++) {
            bannerList[i].order = i;
          }
          this.bannerList = bannerList;
        }
      }
    },
    //转移触发轮播图上传按钮
    handleUploadClick() {
      this.$refs.file.click();
    },
    //上传轮播图
    changeFile(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util.uploadImg_dir(formData, { dir: "appImg" }).then((data) => {
          console.log(data);
          if (data.timestamp) {
            let obj = {
              order: that.bannerList.length,
              name: "",
              url: data.url,
            };
            that.bannerList.push(obj);
          }
        });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //上传分享图
    uploadShareImg(item) {
      var formData = new FormData();
      formData.append("img", item.file);
      uploadImg(formData).then((res) => {
        if (res.code == 0) {
          this.shareCover = res.data.url;
        }
      });
    },
    //上传封面图
    uploadCoverImg(item) {
      var formData = new FormData();
      formData.append("img", item.file);
      uploadImg(formData).then((res) => {
        if (res.code == 0) {
          this.cover = res.data.url;
        }
      });
    },
    //获取礼包分类
    getProductType() {
      getProductType({
        category: "礼包",
      }).then((res) => {
        if (res.code == 0) {
          console.log("分类", res.data);
          this.categoryData = res.data;
        }
      });
    },
    //选择分类
    changeCategory(val) {
      if (val.length > 0) {
        getProductTypeDl({
          id: val[val.length - 1],
        }).then((res) => {
          if (res.code == 0) {
            console.log(res.data);
            this.category_info._id = res.data._id;
            this.category_info.name = res.data.name;
            this.category_info.code = res.data.code;
            this.category_list = res.data.parent_all;
          }
        });
      }
    },
    //返回
    handleBackClick() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.back();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.page {
  background: #fff;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: scroll;
  font-size: 14px;

  .titleView {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: solid 1px #f5f5f5;

    .line {
      width: 2px;
      height: 15px;
      background: #f5882a;
      margin-right: 10px;
    }

    .titleName {
      font-size: 16px;
      color: #2a2a2a;
      font-weight: bold;
    }
  }

  .view {
    flex: 1;
    padding: 20px 0;

    .mr {
      width: 80px;
    }

    .com {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 148px;
      height: 148px;
      line-height: 148px;
      text-align: center;
    }

    .avatar {
      width: 148px;
      height: 148px;
      display: block;
      object-fit: cover;
    }

    .planName {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      border: solid 1px #ececec;
      border-radius: 6px;
      margin-right: 10px;
      margin-bottom: 10px;
    }

    .planNameS {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      border: solid 1px #ececec;
      border-radius: 6px;
      margin-right: 10px;
      margin-bottom: 10px;
      background: #c8c8c8;
    }
  }

  .pageRightBtn {
    height: 90px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.page::-webkit-scrollbar {
  display: none;
}

.imgView {
  flex: 1;

  .imgItem {
    position: relative;
    width: 148px;
    height: 148px;
    margin-right: 20px;
    margin-bottom: 10px;
    float: left;

    img {
      width: 100%;
      height: 100%;
    }

    .closeBtn {
      display: block;
      color: red;
      position: absolute;
      top: -15px;
      right: -15px;
      font-size: 30px;
      z-index: 5;
    }
  }
}

.imgView2 {
  flex: 1;
  display: flex;
  justify-content: center;

  .imgItem {
    position: relative;
    width: 60px;
    height: 60px;
    margin-top: 20px;

    img {
      width: 100%;
      height: 100%;
    }

    .closeBtn {
      display: block;
      color: red;
      position: absolute;
      top: -10px;
      right: -10px;
      font-size: 20px;
      z-index: 5;
    }
  }
}
</style>
